import store from '../../store';
import { mensagemAlertaActions } from '../../features/mensagemAlerta/redux';

const mensagemErroPadrao = 'Ocorreu um erro ao executar a operação.';

export function handleRequestError(error) {
  let mensagem = error.response && error.response.data && error.response.data.mensagem;

  store.dispatch(mensagemAlertaActions.exibirNotificacao(mensagem || mensagemErroPadrao));
}
